// enci.recaptcha.js

/**
 * Executes a reCAPTCHA challenge and returns a token.
 * NOTE: this is installed globally by the reCAPTCHA script in _Host.cshtml.
 *
 * @param {string} sitekey - The reCAPTCHA site key.
 * @param {string} action - The action name for the reCAPTCHA challenge.
 * @returns {Promise<string>} A promise that resolves with the reCAPTCHA token.
 * @throws {Error} If the reCAPTCHA execution fails.
 */
export async function getToken(sitekey, action) {
  try {
    if (typeof grecaptcha === 'undefined' || typeof grecaptcha.execute !== 'function') {
      throw new Error('reCAPTCHA is not loaded or initialized properly');
    }
    return await grecaptcha.execute(sitekey, { action });
  } catch (error) {
    console.error('Error executing reCAPTCHA:', error);
    throw error;
  }
}

// You can add more reCAPTCHA-related functions here if needed in the future
